import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import common from "./utils/common";
import Viewer from 'v-viewer' //图片放大组件
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer);
Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.prototype.common = common;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
